export class CardNumberUtils
{
  public static CardNumberConfig =
    {
      minLength: 15,
      maxLength: 19,
    };

  public static isValidLength(cardNumber: string): boolean
  {
    return cardNumber.length >= this.CardNumberConfig.minLength && cardNumber.length <= this.CardNumberConfig.maxLength;
  }

  public static mask(cardNumber: string): string
  {
    cardNumber = this.unmask(cardNumber);
    return cardNumber.match(/.{1,4}/g).join('-');
  }

  public static unmask(cardNumber: string): string
  {
    cardNumber = cardNumber.replace(/([\D])/g, '');
    return cardNumber;
  }
}
